<template>
    <div>
        <div class="d-flex flex-column pt-6">
            <h4 class="d-flex flex-center m-0">
                <span>Notifications</span>

                <span class="btn btn-success btn-sm ml-2">23 new</span>
            </h4>

            <ul class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x pt-5 px-5" role="tab-list">
                <li class="nav-item">
                    <span data-tab="0" class="nav-link active cursor-pointer" role="tab" @click="activate">Alerts</span>
                </li>
            </ul>
        </div>

        <b-tabs class="hide-tabs" v-model="tab">
            <b-tab>
                <perfect-scrollbar class="navi navi-hover scroll">
                    <template v-for="(notification, i) in notifications">
                        <a href="#" class="navi-item" :key="i">
                            <div class="navi-link">
                                <div class="navi-icon mr-2">
                                    <i v-bind:class="notification.icon"></i>
                                </div>

                                <div class="navi-text">
                                    <div class="font-weight-bold" v-html="notification.title||'&nbsp;'"></div>
                                    <div class="text-muted" v-html="notification.desc||'&nbsp;'"></div>
                                </div>
                            </div>
                        </a>
                    </template>
                </perfect-scrollbar>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: "Notification",
    data() {
        return {
            tab: 0,
            notifications: [
                {
                    title: "New report has been received",
                    desc: "23 hrs ago",
                    icon: "flaticon2-line-chart text-success"
                },
                {
                    title: "Finance report has been generated",
                    desc: "25 hrs ago",
                    icon: "flaticon2-paper-plane text-danger"
                },
                {
                    title: "New order has been received",
                    desc: "2 hrs ago",
                    icon: "flaticon2-user flaticon2-line- text-success"
                },
                {
                    title: "New customer is registered",
                    desc: "3 hrs ago",
                    icon: "flaticon2-pin text-primary"
                },
                {
                    title: "Application has been approved",
                    desc: "3 hrs ago",
                    icon: "flaticon2-sms text-danger"
                },
                {
                    title: "New file has been uploaded",
                    desc: "5 hrs ago",
                    icon: "flaticon2-pie-chart-3 text-warning"
                },
                {
                    title: "New user feedback received",
                    desc: "8 hrs ago",
                    icon: "flaticon-pie-chart-1 text-info"
                },
                {
                    title: "System reboot has been successfully completed",
                    desc: "12 hrs ago",
                    icon: "flaticon2-settings text-success"
                },
                {
                    title: "New order has been placed",
                    desc: "15 hrs ago",
                    icon: "flaticon-safe-shield-protection text-primary"
                },
                {
                    title: "Company meeting canceled",
                    desc: "19 hrs ago",
                    icon: "flaticon2-notification text-primary"
                },
                {
                    title: "New report has been received",
                    desc: "23 hrs ago",
                    icon: "flaticon2-fax text-success"
                },
                {
                    title: "Finance report has been generated",
                    desc: "25 hrs ago",
                    icon: "flaticon-download-1 text-danger"
                }
            ]
        };
    },
    methods: {
        activate(event) {
            const tab = event.target.closest("[role=\"tab-list\"]");
            const links = tab.querySelectorAll(".nav-link");

            for(let i = 0; i < links.length; i++)
                links[i].classList.remove("active");

            this.tab = parseInt(event.target.getAttribute("data-tab"));

            event.target.classList.add("active");
        }
    }
};
</script>

<style lang="scss">
.hide-tabs > div:not(.tab-content) {
    display: none;
}

.hide-tabs {
    .scroll {
        max-height: 40vh;
        position: relative;
    }
}
</style>